var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0C11.6391 0 0 11.6391 0 26C0 40.3609 11.6391 52 26 52C40.3609 52 52 40.3609 52 26C52 11.6391 40.3609 0 26 0ZM36.3797 21.9578C36.3898 22.1813 36.3898 22.4148 36.3898 22.6484C36.3898 29.707 31.0172 37.8523 21.1859 37.8523C18.1695 37.8523 15.3562 36.9688 13 35.4555C13.4164 35.5063 13.843 35.5266 14.2797 35.5266C16.7781 35.5266 19.0836 34.6734 20.9117 33.2414C18.5758 33.2008 16.5953 31.657 15.925 29.5344C16.25 29.5953 16.5852 29.6258 16.9305 29.6258C17.418 29.6258 17.8953 29.5648 18.3422 29.4328C15.8945 28.9453 14.0562 26.782 14.0562 24.1922V24.1313C14.7773 24.5273 15.6 24.7711 16.4734 24.8016C15.0414 23.8469 14.0969 22.2016 14.0969 20.3531C14.0969 19.3781 14.3609 18.4539 14.818 17.6617C17.4586 20.9016 21.3891 23.0242 25.8273 23.2477C25.7359 22.8617 25.6852 22.4555 25.6852 22.0289C25.6852 19.0836 28.082 16.6867 31.0273 16.6867C32.5609 16.6867 33.9523 17.3367 34.9273 18.3727C36.1461 18.1289 37.2836 17.6922 38.3195 17.0727C37.9234 18.3219 37.0703 19.368 35.9734 20.0281C37.05 19.8961 38.0859 19.6117 39.0406 19.1852C38.3297 20.2617 37.4258 21.1961 36.3797 21.9578Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterblack);
export default __webpack_public_path__ + "static/media/twitterblack.17538fa0c87a735797cefa46111c6bd4.svg";
export { ForwardRef as ReactComponent };